import * as React from 'react'
import { Auth } from "aws-amplify";
import { useFormik } from 'formik';
import * as yup from 'yup';
import {Container, TextField} from '@mui/material';
import {Button} from '../../common/Button';
import Error from "../../common/Error";

export interface VerificationRequest {
  code: string
}

const validationSchema = yup.object({
  code: yup
    .string()
    .required('Email is required'),
});

const VerificationForm = ({username, ...props}: {username: string, onSuccess?: () => void}) => {
  const [error, setError] = React.useState(null);
  const formik = useFormik({
    initialValues: {
      code: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values:VerificationRequest) => {
      try {
        await Auth.confirmSignUp(username, values.code);
        if(props.onSuccess) {
          props.onSuccess();
        }
      } catch(error) {
        // @ts-ignore
        setError(error.message);
        console.log(error);
      }
    },
  });

  return (
    <Container maxWidth="xs">
      <form onSubmit={formik.handleSubmit}>
        <TextField
          fullWidth
          variant="outlined"
          margin="normal"
          id="code"
          name="code"
          label="Code"
          value={formik.values.code}
          onChange={formik.handleChange}
          error={formik.touched.code && Boolean(formik.errors.code)}
          helperText={formik.touched.code && formik.errors.code}
        />
        <Button color="primary" variant="contained" fullWidth type="submit" disabled={formik.isSubmitting}>
          Verify
        </Button>
        {error &&
        <Error>{error}</Error>
        }
      </form>
    </Container>

  )

}

export default VerificationForm;